module.exports = __webpack_public_path__ + "static/media/external_env_2_media_5.bfc1a79f.webp";